import React from "react";
import { CookieManager } from "react-cookie-manager";
import "../styles/cookie-consent.css";

const CookieConsent = ({ children }) => (
  <CookieManager
    displayType="popup"
    theme="light"
    showManageButton
    enableFloatingButton
    googleConsentMode
    privacyPolicyUrl="/cookie-policy"
    translations={{
      title: "Cookie preferences",
      message:
        "We use essential cookies to make this website work. With your permission, we also use cookies for analytics, social media and advertising. You can change your preferences at any time.",
      buttonText: "Accept all",
      declineButtonText: "Reject optional cookies",
      manageButtonText: "Manage preferences",
      privacyPolicyText: "Cookie Policy",
    }}
  >
    {children}
  </CookieManager>
);

export default CookieConsent;
